import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../Components/ActionButtonDropdown"
import Pagination from "../../../Core/Pagination/Pagination";
import ListLayout from "../../../Core/Layout/ListLayout";
import Table from "../../../Core/Table/Table";
import Tabs from "../../../Components/Tabs";
import { useGetDoctypeCountQuery } from "../../../store/api/globalapi";
import { useGetBomListQuery } from "../../../store/api/bomapi";
import ExportCSV from '../../../Core/Export/ExportCSV'
import ListFilters from "../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from '../../../store/api/globalapi'
import DelConfirmPopup from "../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../utils/useScreenHeight";

const MainContent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling , pageSize} = useScreenHeight();


    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [bomData, setBomData] = useState({ data: [], total_no_of_records: 0 });
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showFilters, setShowFilters] = useState(false)
    // States used for deleting the records
    const [deleteDoc] = useDeleteDocMutation();
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)


    const { data: BOM_Data, isLoading: BOM_loader, refetch:refetchBOData } = useGetBomListQuery({ page: currentPage - 1, pageSize: pageSize });
    const { data: number_of_count , refetch:refetchBOMCount } = useGetDoctypeCountQuery('BOM');
    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', width: '7%',type:'number' },
        { name: 'name', label: 'Name', width: '20%',type:'text' },
        { name: 'item', label: 'Item', width: '20%',type:'text' },
        { name: 'creation', label: 'Creation Date', type: 'date', width: '15%' },
        {
            name: 'is_active',
            label: 'Active',
            width: '10%',
            type: 'select',
            options: [
                { value: '1', label: 'Yes' },
                { value: '0', label: 'No' },
            ]
        },
        {
            name: 'is_default',
            label: 'Default',
            width: '10%',
            type: 'select',
            options: [
                { value: '1', label: 'Yes' },
                { value: '0', label: 'No' },
            ]
        },
        {
            name: 'docstatus',
            label: 'Status',
            width: '10%',
            type: 'select',
            options: [
                { value: '0', label: 'Draft' },
                { value: '1', label: 'Submitted' },
                { value: '2', label: 'Cancelled' },
            ]
        },
    ];

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
    };

    const handleView = (id) => {
        try {
            navigate(`/assmbly/view-bom/`, { state: { bomId: id } });
        } catch (err) {
            console.error("View failed:", err);
        }
    };

    const handleEdit = async (id) => {
        try {
            navigate(`/assmbly/edit-bom`, { state: { bomId: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

     const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this BOM?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "BOM", name: delSelectedId }).unwrap()
            setDelmessage(`BOM ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelSelectedId(null);
                setDelDone(false)
                refetchBOData();
                refetchBOMCount();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the BOM!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };

    const [columnsConfig, setColumnsConfig] = useState([]);
    useEffect(() => {
        setColumnsConfig([
            {
                header: "S. No.",
                name: "S. No.",
                accessor: "siNo",
                width: '7%',
                visible: true,
                cellRenderer: (row, rowIndex) => rowIndex + 1 + (pageSize * (currentPage - 1)),
                sortable: false
            },
            {
                header: "Name",
                name: "Name",
                accessor: "name",
                visible: true,
                width: '20%',
                sortable: true
            },
            {
                header: "Item",
                name: "Item",
                accessor: "item",
                visible: true,
                width: '20%',
                sortable: true
            },
            {
                header: "Active",
                name: "Active",
                accessor: "is_active",
                width: '10%',
                visible: false,
                sortable: true,
                cellRenderer: (row) => row.is_active === 1 ? 'Yes' : 'No'
            },
            {
                header: "Default",
                name: "Default",
                accessor: "is_default",
                width: '10%',
                sortable: true,
                cellRenderer: (row) => row.is_default === 1 ? 'Yes' : 'No'
            },
            {
                header: "Creation Date",
                name: "Creation Date",
                accessor: "creation",
                width: '15%',
                sortable: true,
                visible:true,
                sortFn: (a, b) => new Date(a.creation) - new Date(b.creation),
                cellRenderer: (row) => new Date(row.creation).toLocaleDateString()
            },
            {
                header: "Status",
                name: "Status",
                accessor: "docstatus",
                width: '10%',
                sortable: true,
                visible:true,
                cellRenderer: (row) => {
                    let statusText, color;
    
                    switch (row.docstatus) {
                        case 0:
                            statusText = 'Draft';
                            color = '#6366F1';
                            break;
                        case 1:
                            statusText = 'Submitted';
                            color = '#16A34A';
                            break;
                        case 2:
                            statusText = 'Cancelled';
                            color = '#EF4444';
                            break;
                        default:
                            statusText = 'Unknown';
                            color = '#6B7280';
                    }
    
                    return (
                        <span style={{
    
                            color: color,
                            display: 'inline-block',
    
                        }}>
                            {statusText}
                        </span>
                    );
                }
            },
            {
                header: "Action",
                name: "Action",
                accessor:"action",
                visible: true,
                width: '10%',
                sortable: false,
                cellRenderer: (row) => (
                    <ActionButtonDropdown
                        id={row.name}
                        onView={() => handleView(row.name)}
                        onEdit={() => handleEdit(row.name)}
                        onDelete={() => handleDelete(row.name)}
                    />
                )
            },
        ])},[currentPage])

    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/assmbly/create-bom",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add BOM"
        }
    ];

    useEffect(() => {
        if (BOM_Data) {
            setBomData({
                data: BOM_Data.data || [],
                total_no_of_records: number_of_count?.message || (BOM_Data.data?.length || 0)
                // total_no_of_records: 5526

            });
        } else {
            setBomData({
                data: [],
                total_no_of_records: 0
            });
        }
    }, [BOM_Data, number_of_count, currentPage, screenHeight, screenScaling , pageSize]);

    useEffect(() => {
        setLoading(BOM_loader);
    }, [BOM_loader]);
    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Manufacturing" },
                    { label: "BOM List", style: { color: '#391F84' } }
                ]}
                actionButtons={actionButtons}
            >
                {
                    showFilters && <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                }

                {showColumnConfig &&
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="BOM"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "action","name", "creation", "docstatus", "item"]}
                    />}
                <Table
                    columns={visibleColumns}
                    data={bomData.data}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={bomData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {showExportPopup && (
                    <ExportCSV
                        doctype="BOM"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
            </ListLayout>
        </div>
    );
};

export default MainContent;